import { ExperimentInfoType } from "../types/experiments";

export const parseExperimentResponse = (response: any): ExperimentInfoType => {
  return {
    id: response?.id,
    name: response?.name,
    description: response?.description,
    status: response?.status,
    module: response?.module,
    testGroups: response?.test_group_configs?.map((testGroup: any) => ({
      segmentId: testGroup?.segment_id,
      name: testGroup?.name,
      description: testGroup?.description,
      trafficPercentage: testGroup?.percent_share,
      isControlGroup: testGroup?.is_control_group,
    })),
  };
};